import * as React from 'react';

import { uniq } from 'lodash';

import { Select, SelectProps } from '@emburse/ui-core';

import { toTitleCase } from '@Shared/helpers/textFormatter';
import {
  AccountCapabilitiesCard,
  AccountCapabilitiesCardAllowanceIntervalEnum,
  AccountCapabilitiesVirtualCard,
  CAPABILITIES_INTERVAL_ORDER,
  INTERVAL_SHORT_DISPLAY_NAMES
} from '@Shared/interfaces/CardsGatewayInterfaces';

interface ICapabilitiesIntervalFieldProps extends Omit<SelectProps, 'children' | 'id'> {
  capabilities: AccountCapabilitiesCard | AccountCapabilitiesVirtualCard;
}

export const CapabilitiesIntervalFieldBase: React.ForwardRefRenderFunction<unknown, ICapabilitiesIntervalFieldProps> = (
  { capabilities, value = '', ...rest },
  ref
) => {
  const intervalOptions =
    capabilities &&
    uniq(
      capabilities.allowance.interval
        .slice()
        .sort((a, b) => CAPABILITIES_INTERVAL_ORDER.indexOf(a) - CAPABILITIES_INTERVAL_ORDER.indexOf(b))
        .map((interval) => interval.toLowerCase())
    ).map((interval) => ({
      label: toTitleCase(INTERVAL_SHORT_DISPLAY_NAMES[interval as AccountCapabilitiesCardAllowanceIntervalEnum]),
      value: interval.toLowerCase()
    }));

  return (
    <Select
      native
      required
      fullWidth
      label="Frequency"
      name="capabilities-interval-select"
      id="capabilities-interval-select"
      value={value}
      {...rest}
    >
      {intervalOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Select>
  );
};

export const CapabilitiesIntervalField = React.memo(React.forwardRef(CapabilitiesIntervalFieldBase));
